<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-08-08 17:23:56
 * @LastEditTime: 2024-05-02 21:34:24
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <div class="home">
        <div class="home-header">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                    <img src="../../assets/index-slide-bac.png" alt=""/>
                </van-swipe-item>
                <!-- <van-swipe-item>2</van-swipe-item>
                <van-swipe-item>3</van-swipe-item>
                <van-swipe-item>4</van-swipe-item> -->
            </van-swipe>
            <!-- <video
                loop
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-playsinline
                x5-video-player-type="h5"
                style="width: 100%;height: 100%"
                muted="true"
                id="videoId"
            >
                <source src="../../assets/5.mp4" type="video/mp4" />
            </video> -->
        </div>
        <div class="home-content">
            <div class="home-content-title">"某"府治丧</div>
            <div class="home-content-introduction">
                <div class="text">
                    数字治丧府牌服务融合传统殡葬文化与信息化技术，使家属能自助上传逝者信息，生成个性化电子治丧府牌。
                </div>
                <div class="text">
                    此服务致力于便民惠民，操作简便，旨在帮助治丧亲友在吊唁时迅速、准确地找到对应礼厅或灵堂。
                </div>
            </div>
            <div class="home-content-list" v-if="code">
                <div class="list" @click="goRecord" v-if="hallid && qrticket">
                    <img class="icon" src="../../assets/index-icon-record.png" alt=""/>
                    信息录入
                </div>
                <div class="list" @click="goOrder">
                    <img class="icon" src="../../assets/index-icon-order.png" alt=""/>
                    订单信息
                </div>
                <div class="list" @click="goInfo">
                    <img class="icon" src="../../assets/index-icon-edit.png" alt=""/>
                    信息修改
                </div>
            </div>
        </div>
<!--        <div class="contract">-->
<!--            <div class="text">咨询热线：4008-088-711</div>-->
<!--        </div>-->
    </div>
</template>
<script>
import preventBack from 'vue-prevent-browser-back';
//组件内单独引入
export default {
    name: "home",
    data() {
        return {
            code: this.$utils.queryStringNormalURL("code"),
            hallid: this.$utils.queryStringNormalURL("hallid"),
            qrticket: this.$utils.queryStringNormalURL("qrticket")
        };
    },
    mixins: [preventBack],
    components: {},
    computed: {},
    methods: {
        goRecord() {
            this.$router.push({
                name: 'record'
            })
        },
        goInfo() {
            let self = this;
            setTimeout(()=>{
                this.$utils.checkToken().then(res => {
                    this.$api.index.orderInfo().then(res => {
                        console.log(res);
                        if (!res) {
                            self.$dialog.toast('还没有以往信息可编辑！')
                            return
                        }
                        this.$router.push({
                            name: 'record',
                            query: {
                                data: JSON.stringify(res)
                            }
                        })
                    })
                })
            },300)
        },
        goOrder() {
            setTimeout(()=>{
                this.$router.push({
                    name: 'order'
                })
            },300)
        },
        // 获取微信授权接口
        doGetWxAuthorize() {
            var data = {}
            if (this.hallid && this.qrticket) {
                data = {
                    hallid: this.hallid,
                    qrticket: this.qrticket
                }
            }
            this.$api.index.getWxAuthorize(data).then(res => {
                console.log(res)
                if (res.url) {
                    sessionStorage.useCode = false;
                    window.location.href = res.url;
                }
            })
        },
        // 获取用户信息接口
        doGetWxUserByCode() {
            this.$api.index.getWxUserByCode({code: this.code}).then(res => {
                console.log(res)
                if (res) {
                    sessionStorage.access_token = res.token.access_token;
                    sessionStorage.refresh_token = res.token.refresh_token;
                    sessionStorage.expires_in = res.token.expires_in;
                    sessionStorage.userInfo = JSON.stringify(res.user);
                    let date = parseInt(this.$moment(new Date()).valueOf() / 1000);
                    sessionStorage.requestTime = date;//请求token 的时间
                    sessionStorage.useCode = "use";
                }
            })
        },
        // 获取token接口
        doGetToken() {
            var data = {}
            if (this.hallid && this.qrticket) {
                data = {
                    hallid: this.hallid,
                    qrticket: this.qrticket
                }
            }
            this.$api.index.getToken(data).then(res => {
                console.log(res)
                sessionStorage.access_token = res.access_token;
                sessionStorage.refresh_token = res.refresh_token;
                sessionStorage.expires_in = res.expires_in;
                if (this.hallid && !res.hall_name) {//有厅id但是没有厅名称不给进
                    this.$router.replace({
                        name: 'error'
                    })
                    return
                }
                sessionStorage.hallid = res.hall_id;
                sessionStorage.hall_name = res.hall_name;
                let date = parseInt(this.$moment(new Date()).valueOf() / 1000);
                sessionStorage.requestTime = date;//请求token 的时间
                this.doGetWxAuthorize();
                // if (process.env.NODE_ENV == 'production') {
                //     this.doGetWxAuthorize();
                // } else {
                //     console.log(11111,testData);
                //     sessionStorage.expires_in = testData.token.expires_in;
                //     sessionStorage.access_token = testData.token.access_token;
                //     sessionStorage.refresh_token = testData.token.refresh_token;
                //     sessionStorage.userInfo = JSON.stringify(testData.user);
                //     // let date = parseInt(this.$moment(new Date()).valueOf() / 1000);
                //     // sessionStorage.requestTime = date;//请求token 的时间
                // }
            })
        }
    },

    mounted() {
        // this.$nextTick(() => {
        //     const video = document.getElementById('videoId')
        //     console.log(video)
        //     // 一般情况下，这样就可以自动播放了，但是一些奇葩iPhone机不可以
        //     video.play()
        //     // 必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
        //     document.addEventListener('WeixinJSBridgeReady', () => {
        //         video.play()
        //     },false)
        // })

    },
    created() {
        if (this.code && sessionStorage.useCode != "use") {
            this.doGetWxUserByCode();
        } else {
            // if(!sessionStorage.userInfo){
            this.code = "";
            this.doGetToken();
            // }
        }
    },
    watch: {},
};
</script>
<style rel="stylesheet/scss" lang="scss">
// .van-pull-refresh {
//     height: 100vh;
// }

.van-loading {
    margin: 0 auto;
    width: px2rem(200);
}

.van-popup {
    background: inherit;
}

.home {
    width: 100%;
    min-height: 100%;

    &-header {
        width: 100%;
        height: px2rem(424);

        .my-swipe .van-swipe-item {
            color: #fff;
            font-size: 20px;
            height: px2rem(424);
            line-height: px2rem(424);
            text-align: center;
            background-color: #39a9ed;

            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }

        //background: #000;
    }

    &-content {
        padding: 0 px2rem(28);
        overflow: hidden;

        &-title {
            width: px2rem(362);
            height: px2rem(86);
            margin: 0 auto;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: px2rem(38);
            color: #765733;
            margin-top: px2rem(40);
            background: url(../../assets/index-content-title.png) no-repeat;
            background-size: 100% 100%;
        }

        &-introduction {
            font-size: px2rem(28);
            color: #444444;
            line-height: px2rem(44);
            margin-top: px2rem(32);
            .text {
                text-indent: px2rem(56);
            }
        }

        &-list {
            width: 100%;
            margin-top: px2rem(42);

            .list {
                width: px2rem(694);
                height: px2rem(144);
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: px2rem(32);
                color: #ffffff;
                margin-bottom: px2rem(16);

                .icon {
                    display: block;
                    width: px2rem(64);
                    height: px2rem(64);
                    margin-right: px2rem(28);
                    margin-left: px2rem(224);
                }
            }

            & > .list:nth-child(1) {
                background: url(../../assets/index-record-bac.png) no-repeat;
                background-size: 100% 100%;
            }

            & > .list:nth-child(2) {
                background: url(../../assets/index-edit-bac.png) no-repeat;
                background-size: 100% 100%;
            }

            & > .list:nth-child(3) {
                background: url(../../assets/index-order-bac.png) no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .contract {
        text-align: center;
        font-size: px2rem(30);
        position: absolute;
        left: px2rem(20);
        right: px2rem(20);
        bottom: px2rem(40);
    }
}
</style>
